/* eslint-disable */
import errors from './utils/errors';
import helper from './utils/helper';

export default (field) => {
  const validationResult = {
    valid: true,
    error: '',
  };

  if (field.required && helper.isEmpty(field.value)) {
    validationResult.valid = false;
    validationResult.error = field.requiredMessage || errors.required.replace('%1', field.name);
  }


  if (validationResult.valid && field.validation && field.value) {
    switch (field.validation) {
      case 'text': {
        if (helper.isBadText(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.text.replace('%1', field.name);
        }
        break;
      }
      case 'email': {
        if (!helper.isEmail(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.email;
        }
        break;
      }
      case 'date': {
        if (!helper.isDate(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.date;
        }
        break;
      }
      case 'password': {
        if (!helper.isPasswordStrong(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.password_incorrect;
        }
        break;
      }

      case 'repassword': {
        if (!helper.arePasswordsSame(field.equalTo, field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.repassword;
        }
        break;
      }

      case 'tel': {
        if (!helper.isPhone(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.phone;
        }
        break;
      }

      case 'number': {
        if (!helper.isNumber(field.value)) {
          validationResult.valid = false;
          validationResult.error = field.validationMessage || errors.number.replace('%1', field.name);
        }
        break;
      }
    }
  }

  return validationResult;
};



// WEBPACK FOOTER //
// ./scripts/blocks/form/validator/index.js